import {
    registerClocksHandler,
    registerClocksSub,
    start as startEventsClocks,
    stop as stopEventsClocks
} from '@/events/services/clocks';

registerClocksHandler('recently-visited.tick', ['recently-visited', 'clock']);
registerClocksSub('recently-visited.tick.clock', ['recently-visited', 'clock']);

let clockTimer;
export const startClocks = () => {
    clockTimer = startEventsClocks('recently-visited.tick');
};
export const stopClocks = () => {
    stopEventsClocks(clockTimer);
};
